import type { ReactNode } from "react";
import { DelayedEnter } from "../shared/motion/delayed-enter";
import { useQuestionnaireFlow } from "./questionnaire-context";

type TStepEnterProps = {
	children: ReactNode;
	className?: string;
	delayMs: number;
	durationMs: number;
	enabled: boolean;
};

export function StepEnter({ children, className, delayMs, durationMs, enabled }: TStepEnterProps) {
	const { stepIntro } = useQuestionnaireFlow();
	const playing = enabled && stepIntro === "playing";
	const visible = !enabled || stepIntro !== "pending";

	return (
		<DelayedEnter
			className={className}
			delayMs={delayMs}
			durationMs={durationMs}
			enabled={enabled}
			playing={playing}
			visible={visible}
		>
			{children}
		</DelayedEnter>
	);
}
